<h2 class="first_title">Consultazione</h2>
<div export-help></div>
<ul class="pathbar amministrazione">
  <li><a [routerLink]="[urlCancelleria]">Cancelleria telematica</a></li>
  <li>Consultazione</li>
</ul>
<div class="content-page-wrapper">
  <div class="standardpanel">
    <div class="titleblock">
      <h3 class="title1levelNoMargin">Consultazione</h3>
    </div>
    <form [formGroup]="form">
      <div class="container_fieldset">
        <fieldset class="form-group pb-15">
          <legend>Parametri di consultazione</legend>
          <div class="col-xs-12 col-sm-12">
            <div class="row">
              <div *ngFor="let question of questions" [class]="question.size">
                <dynamic-form-field class="form-element" [form]="form" [question]="question"></dynamic-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 col-xs-12">
                <span class="mandatory">
                  <p>
                    <em>* Campi obbligatori</em>
                  </p>
                  <p>
                    <em *ngIf="needsAdditionalInfo()">* Inserire almeno un parametro non obbligatorio</em>
                  </p>
                </span>
              </div>
              <div class="col-xs-3 col-sm-3">
                <button class="btn btn-secondary reset" type="reset" aria-label="Reset" (click)="onReset()">Reset</button>
              </div>
              <div class="col-xs-3 col-sm-3">
                <button class="btn btn-primary search" type="submit" aria-label="Cerca" (click)="onSearch()" [disabled]="form.invalid">Cerca</button>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

    </form>

    <div *ngIf="consultations && consultations.length > 0" class="container_dati_generali">
      <app-consultazione-list
        [consultations]="consultations"
        (createEvent)="createPractice($event)">
      </app-consultazione-list>
    </div>

    <div *ngIf="hasSearched && consultations && consultations.length === 0"  class="row">
      <div class="col-sm-12 no-result">
        La consultazione non ha prodotto risultati
      </div>
    </div>

  </div>
</div>
